import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { OpenPopin } from '@app/store';

/**
 * this event can be used to track opening of the pop in.
 */
const events = getEvents((action: OpenPopin) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'popinOpen',
      popinName: action.payload.name
    }
  }
]);

export default events;
